import React from 'react';
import {
  SortContainer,
  SortHeading,
  SortImg,
  SortText,
  SortButton,
  SortButtonText,
} from './style';
import SortSquare from '../../static/img/sort-square.svg';

const SortItems = ({
  sortItem,
  setSortItem,
  firstSortText,
  secondSortText,
}) => {
  return (
    <SortContainer>
      <SortHeading>
        <SortImg src={SortSquare} />
        <SortText><span data-dd-privacy="mask-user-input">Sort by :</span></SortText>
      </SortHeading>

      <>
        <SortButton isClicked={sortItem} onClick={() => setSortItem(true)}>
          <SortButtonText isClicked={sortItem}><span data-dd-privacy={['New to Old', 'Old to New'].includes(firstSortText) ? 'mask-user-input' : undefined}>{firstSortText}</span></SortButtonText>
        </SortButton>
        <SortButton
          isClicked={sortItem === false}
          onClick={() => setSortItem(false)}
        >
          <SortButtonText isClicked={sortItem === false}>
            <span data-dd-privacy={['New to Old', 'Old to New'].includes(secondSortText) ? 'mask-user-input' : undefined}>{secondSortText}</span>
          </SortButtonText>
        </SortButton>
      </>
    </SortContainer>
  );
};

export default SortItems;
